import Yn from "axios";
import { useQuery as r, useMutation as u, useQueryClient as a } from "@tanstack/react-query";
const ss = "CONTACTS", Pt = "CONTACTS_CLIENTS", hn = "CONTACTS_CLIENTS_GET", F = "CONTACTS_CLIENTES_COMPANY", fn = "CONTACTS_GET", ns = "CONTACTS_ACADEMIC_LEVELS", rs = "CONTACTS_ACCOUNT_TYPES", P = "CONTACTS_ADDRESS_TYPES", q = "CONTACTS_COMPANY_TYPES", $ = "CONTACTS_COMPANIES", Ln = "CONTACTS_SPOUSES", Vn = "CONTACTS_ADDRESS", vn = "CONTACTS_LABOR", m = "CONTACTS_FAMILY_RELATIONSHIP", us = "CONTACTS_GENDERS", M = "CONTACTS_MARITAL_STATUS", D = "CONTACTS_NATIONALITIES", K = "CONTACTS_OCCUPATION_TYPES", w = "CONTACTS_PROFESSION_TYPES", Bn = "CONTACTS_FILES_FOTOS", yn = "CONTACTS_FILES_FOTOS_PROC", U = "CONTACT_TYPES", as = "CONTACT_TYPES_DNI", Gn = "CONTACT_TYPES_CLIENTS", qt = "INVENTORY_PRODUCTS", os = "INVENTORY_PRODUCTS_TYPES", Y = "INVENTORY_PRODUCTS_BRANDS", Re = "INVENTORY_PRODUCTS_PRICES", cs = "INVENTORY_PRODUCTS_QUALITIES", bn = "INVENTORY_PRODUCTS_WAREHOUSES", h = "INVENTORY_PRODUCTS_CATEGORIES", Qn = "INVENTORY_PRODUCTS_PHOTOGRAPHY", is = "INVENTORY_PRODUCTS_LIST_PRICES", ls = "INVENTORY_PRODUCTS_UNITS", f = "INVENTORY_PRODUCTS_BRANDS_MODELS", Hn = "INVENTORY_PRODUCTS_VEHICLE", Tn = "INVENTORY_PRODUCTS_GET", jn = "INVENTORY_PRODUCTS_PRICES_DELETE", kn = "INVENTORY_PRODUCTS_GET_BY_CODE", Wn = "INVENTORY_PRODUCTS_PRICES_UPDATE", zn = "INVENTORY_VEHICLES", Jn = "INVENTORY_VEHICLES_GET", ys = "INVENTORY_VEHICLE_CYLINDERS", xn = "INVENTORY_VEHICLE_CONDITIONS", L = "INVENTORY_VEHICLE_FUELS_TYPE", Ts = "INVENTORY_VEHICLE_TRANSMISSIONS_TYPE", Zn = "INVENTORY_VEHICLES_GET_BY_CHASSIS", Xn = "INVENTORY_VEHICLES_GET_BY_REGISTRATION_NUMBER", er = "INVENTORY_VEHICLE_LOADING_CAPACITIES", tr = "INVENTORY_VEHICLE_ACCESSORY_CATEGORIES", sr = "INVENTORY_VEHICLE_ACCESSORY_CATEGORY_TYPES", E = "INVENTORY_ADJUSTMENTS", nr = "INVENTORY_ADJUSTMENTS_GET", In = "INVENTORY_ADJUSTMENTS_DETAILS", V = "INVENTORY_ADJUSTMENTS_REASONS", he = "INVENTORY_TRANSFERS", En = "INVENTORY_TRANSFERS_GET", Is = "INVENTORY_TRANSFERS_DETAILS", Es = "FINANCE", rr = "FINANCE_GET", ds = "FINANCE_TYPES", De = "FINANCE_GROUPS", dn = "FINANCE_ASSURANCE", ke = "FINANCE_REHOOKS", Cs = "FINANCE_AMORTIZATIONS", Ss = "FINANCE_METHOD_PAYMENTS", $t = "FINANCE_ASSURANCE_TYPES", ur = "FINANCE_ASSURANCE_PRODUCTS", As = "FREQUENCY_PAYMENT_TYPES", Ns = "FINANCE_LATE_PAYMENT_CALC_TYPES", mt = "FINANCE_CONCEPTS_CLOSING_TYPES", Cn = "FINANCE_CONCEPTS_CLOSING_TYPES_CALCULATE", Ke = "USERS", ar = "USERS_SIGN_UP", Sn = "USERS_GET_ME", An = "USERS_PERMISOS", Nn = "AUTH", Rn = "USERS_NAMES", gn = "REFRESH_TOKEN", _n = "CHANGE_PASSWORD", v = "TEMPLATES", B = "TEMPLATES_TYPES", G = "GENERAL_SETTINGS", On = "GENERAL_SETTINGS_PROC", pn = "GENERAL_SETTINGS_UPDATE_ALL", Rs = "GENERAL_SETTINGS_OPTIONS", gs = "GENERAL_SETTINGS_CATEGORIES", _s = "ACCOUNTS", we = "TAXES", Mt = "WAREHOUSES", b = "DOCUMENTS", R = "CURRENCIES", Fn = "CURRENCIES_SWITCH", Q = "BANKS", g = "COUNTRIES", S = "PROVINCES", _ = "MUNICIPALITIES", H = "SECTORS", Os = "STATUS", ps = "VOUCHER_TYPES", We = "ROLES", or = "ROLES_BY_USERNAME", Fs = "MONTHS", Ps = "MODULES", i = "MUTATION_CREATE", l = "MUTATION_DELETE", c = "MUTATION_UPDATE", fi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACCOUNTS: _s,
  AUTH: Nn,
  BANKS: Q,
  CHANGE_PASSWORD: _n,
  CONTACTS: ss,
  CONTACTS_ACADEMIC_LEVELS: ns,
  CONTACTS_ACCOUNT_TYPES: rs,
  CONTACTS_ADDRESS: Vn,
  CONTACTS_ADDRESS_TYPES: P,
  CONTACTS_CLIENTES_COMPANY: F,
  CONTACTS_CLIENTS: Pt,
  CONTACTS_CLIENTS_GET: hn,
  CONTACTS_COMPANIES: $,
  CONTACTS_COMPANY_TYPES: q,
  CONTACTS_FAMILY_RELATIONSHIP: m,
  CONTACTS_FILES_FOTOS: Bn,
  CONTACTS_FILES_FOTOS_PROC: yn,
  CONTACTS_GENDERS: us,
  CONTACTS_GET: fn,
  CONTACTS_LABOR: vn,
  CONTACTS_MARITAL_STATUS: M,
  CONTACTS_NATIONALITIES: D,
  CONTACTS_OCCUPATION_TYPES: K,
  CONTACTS_PROFESSION_TYPES: w,
  CONTACTS_SPOUSES: Ln,
  CONTACT_TYPES: U,
  CONTACT_TYPES_CLIENTS: Gn,
  CONTACT_TYPES_DNI: as,
  COUNTRIES: g,
  CURRENCIES: R,
  CURRENCIES_SWITCH: Fn,
  DOCUMENTS: b,
  FINANCE: Es,
  FINANCE_AMORTIZATIONS: Cs,
  FINANCE_ASSURANCE: dn,
  FINANCE_ASSURANCE_PRODUCTS: ur,
  FINANCE_ASSURANCE_TYPES: $t,
  FINANCE_CONCEPTS_CLOSING_TYPES: mt,
  FINANCE_CONCEPTS_CLOSING_TYPES_CALCULATE: Cn,
  FINANCE_GET: rr,
  FINANCE_GROUPS: De,
  FINANCE_LATE_PAYMENT_CALC_TYPES: Ns,
  FINANCE_METHOD_PAYMENTS: Ss,
  FINANCE_REHOOKS: ke,
  FINANCE_TYPES: ds,
  FREQUENCY_PAYMENT_TYPES: As,
  GENERAL_SETTINGS: G,
  GENERAL_SETTINGS_CATEGORIES: gs,
  GENERAL_SETTINGS_OPTIONS: Rs,
  GENERAL_SETTINGS_PROC: On,
  GENERAL_SETTINGS_UPDATE_ALL: pn,
  INVENTORY_ADJUSTMENTS: E,
  INVENTORY_ADJUSTMENTS_DETAILS: In,
  INVENTORY_ADJUSTMENTS_GET: nr,
  INVENTORY_ADJUSTMENTS_REASONS: V,
  INVENTORY_PRODUCTS: qt,
  INVENTORY_PRODUCTS_BRANDS: Y,
  INVENTORY_PRODUCTS_BRANDS_MODELS: f,
  INVENTORY_PRODUCTS_CATEGORIES: h,
  INVENTORY_PRODUCTS_GET: Tn,
  INVENTORY_PRODUCTS_GET_BY_CODE: kn,
  INVENTORY_PRODUCTS_LIST_PRICES: is,
  INVENTORY_PRODUCTS_PHOTOGRAPHY: Qn,
  INVENTORY_PRODUCTS_PRICES: Re,
  INVENTORY_PRODUCTS_PRICES_DELETE: jn,
  INVENTORY_PRODUCTS_PRICES_UPDATE: Wn,
  INVENTORY_PRODUCTS_QUALITIES: cs,
  INVENTORY_PRODUCTS_TYPES: os,
  INVENTORY_PRODUCTS_UNITS: ls,
  INVENTORY_PRODUCTS_VEHICLE: Hn,
  INVENTORY_PRODUCTS_WAREHOUSES: bn,
  INVENTORY_TRANSFERS: he,
  INVENTORY_TRANSFERS_DETAILS: Is,
  INVENTORY_TRANSFERS_GET: En,
  INVENTORY_VEHICLES: zn,
  INVENTORY_VEHICLES_GET: Jn,
  INVENTORY_VEHICLES_GET_BY_CHASSIS: Zn,
  INVENTORY_VEHICLES_GET_BY_REGISTRATION_NUMBER: Xn,
  INVENTORY_VEHICLE_ACCESSORY_CATEGORIES: tr,
  INVENTORY_VEHICLE_ACCESSORY_CATEGORY_TYPES: sr,
  INVENTORY_VEHICLE_CONDITIONS: xn,
  INVENTORY_VEHICLE_CYLINDERS: ys,
  INVENTORY_VEHICLE_FUELS_TYPE: L,
  INVENTORY_VEHICLE_LOADING_CAPACITIES: er,
  INVENTORY_VEHICLE_TRANSMISSIONS_TYPE: Ts,
  MODULES: Ps,
  MONTHS: Fs,
  MUNICIPALITIES: _,
  MUTATION_CREATE: i,
  MUTATION_DELETE: l,
  MUTATION_UPDATE: c,
  PROVINCES: S,
  REFRESH_TOKEN: gn,
  ROLES: We,
  ROLES_BY_USERNAME: or,
  SECTORS: H,
  STATUS: Os,
  TAXES: we,
  TEMPLATES: v,
  TEMPLATES_TYPES: B,
  USERS: Ke,
  USERS_GET_ME: Sn,
  USERS_NAMES: Rn,
  USERS_PERMISOS: An,
  USERS_SIGN_UP: ar,
  VOUCHER_TYPES: ps,
  WAREHOUSES: Mt
}, Symbol.toStringTag, { value: "Module" })), qs = 1, cr = 2, ir = 3, lr = 4, yr = 5, Tr = 6, Ir = 7, Er = 8, dr = 9, Cr = 10, Sr = 11, Ar = 12, Nr = 13, Rr = 14, o = 15, gr = 16, _r = 17, Or = 18, pr = 19, Fr = 20, Pr = 21, qr = 22, $r = 23, mr = 24, Mr = 25, Dr = 26, Kr = 27, wr = 28, Ur = 29, Li = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVE_CODE: qs,
  ANNULLED_CODE: lr,
  APPROVED_CODE: Dr,
  BLOCKED_CODE: gr,
  CLOSED_CODE: Mr,
  COMMITMENT_CODE: Sr,
  DELETED_CODE: o,
  DISPUTE_CODE: Nr,
  DRAFT_CODE: ir,
  FINALIZED_CODE: mr,
  FINISHED_CODE: Fr,
  HIDDEN_CODE: Ur,
  INACTIVE_CODE: cr,
  INCOMPLETE_FINISHED_CODE: Pr,
  INVOICED_CODE: qr,
  NOT_RECONCILED_CODE: Or,
  OPENED_CODE: Kr,
  PASSED_TO_LEGAL_CODE: Ir,
  PAYMENT_REPORTED_CODE: Ar,
  PENDING_APPROVAL_CODE: yr,
  PENDING_CODE: $r,
  RECONCILED_CODE: _r,
  RECURRING_CODE: pr,
  REFINANCED_CODE: dr,
  REJECTED_CODE: Tr,
  RENOVATED_CODE: wr,
  SEIZED_CODE: Er,
  SETTLED_CODE: Cr,
  UNCOLLECTIBLE_CODE: Rr
}, Symbol.toStringTag, { value: "Module" })), tn = "Contactos", Pn = "Clientes", Yr = `${Pn}/GetClientes`, j = "ClientesDatosLaboralesEmpresas", k = "ClientesTiposNivelesAcademicos", Yt = "ClientesTiposCuentasBancarias", W = "ContactosTiposDirecciones", z = "ClientesEmpresasPropiasTiposEmpresas", J = "ClientesEmpresasPropias", Pe = "ClientesTiposParentescos", ht = "ContactosTiposGeneros", x = "ClientesTiposEstadosCiviles", Z = "ClientesTiposNacionalidades", X = "ClientesTiposOcupaciones", ee = "ClientesTiposProfesiones", ft = "ContactosArchivosFotos", sn = "ContactosArchivosFotos/GetFotografiaByContacto", te = "ContactosTipos", Lt = "ContactosTiposDNI", St = "Productos", Vt = "ProductosTipos", se = "ProductosMarcas", pt = "ProductosPrecios", ve = "ProductosCalidades", qe = "ProductosAlmacenes", ne = "ProductosCategorias", vt = "ProductosListasPrecios", Be = "ProductosTiposUnidadesMedidas", re = "ProductosMarcasModelos", hr = `${St}/GetProductos`, fr = `${pt}/EliminarPrecio`, Lr = `${St}/GetProductosByCodigoUnico`, O = `${pt}/ActualizarPrecio`, ue = "VehiculosCilindros", ae = "VehiculosCondiciones", oe = "VehiculosTiposCombustibles", ce = "VehiculosTiposTransmision", ie = "VehiculosTiposCapacidadCarga", Ge = "VehiculosAccesoriosCategorias", be = "VehiculosAccesoriosTipos", d = "InventariosAjustes", Vr = `${d}/GetInventariosAjustes`, vr = "InventariosAjustesDetalles", le = "ProductosTiposRazonesAjustes", C = "AlmacenesTransferencias", Br = `${C}/GetAlmacenesTransferencias`, Bt = "AlmacenesTransferenciasDetalle", ye = "Financiamientos", Gt = "FinanciamientosTipos", Te = "FinanciamientosGrupos", $e = "FinanciamientosGarantias", Ie = "FinanciamientosReenganches", bt = "FinanciamientosTiposAmortizaciones", Qt = "FinanciamientosTiposFormasPagos", Ht = "FinanciamientosTiposGarantias", Ct = "FinanciamientosGarantiasProductos", jt = "TiposFrecuenciasPagos", kt = "FinanciamientosTiposMorasFormasCalculos", je = "FinanciamientosTiposConceptosGastosCierres", Gr = `${je}/CalcularGastoLegal`, Me = "Users", br = "SignUp", Qr = `${Me}/GetMe`, Hr = `${Me}/GetPermisos`, nn = "Auth", jr = `${Me}/GetNames`, rn = "Refresh", Ot = "ChangePassword", Ee = "Plantillas", de = "PlantillasTipos", me = "ConfiguracionesGenerales", un = "ObtenerConfiguracionesGenerales", an = "ActualizarConfiguraciones", on = "ConfiguracionesGeneralesOpciones", Wt = "ConfiguracionesGeneralesCategorias", zt = "CatalogoCuentas", Qe = "ImpuestosTipos", Jt = "Almacenes", Ce = "Documentos", Se = "Monedas", cn = "Monedas/CambiarAPrincipal", Ae = "Bancos", Ne = "Paises", A = "PaisesProvincias", N = "PaisesProvinciasMunicipios", p = "PaisesProvinciasMunicipiosSectores", xt = "Estados", Zt = "FuentesComprobantesTipos", He = "Roles", kr = "Roles/GetByUserId", Xt = "Meses", ln = "Modulos", Wr = [
  {
    "message-en": "There was an error connecting to the server.",
    "message-es": "Hubo un error al conectar con el servidor.",
    keys: [
      "network"
    ]
  },
  {
    "message-en": "Timeout. Please try again later.",
    "message-es": "Tiempo de espera agotado. Por favor, inténtalo nuevamente más tarde.",
    keys: [
      "timeout"
    ]
  },
  {
    "message-en": "There was an error with the user.",
    "message-es": "Hubo un error con el usuario.",
    keys: [
      "user"
    ]
  },
  {
    "message-en": "The indicated token does not belong to this user or is expired.",
    "message-es": "El token indicado no pertenece a este usuario o está caducado.",
    keys: [
      "token",
      "expired"
    ]
  },
  {
    "message-en": "The record you are trying to add already exists.",
    "message-es": "El registro que intentas agregar ya existe.",
    keys: [
      "duplicate",
      "UNIQUE KEY"
    ]
  },
  {
    "message-en": "This error is not being handled.",
    "message-es": "Este error no se está manejando.",
    keys: []
  }
], zr = () => {
  if (typeof window < "u" && window.localStorage) {
    const e = window.localStorage.getItem("NubeteckConfig");
    if (typeof e == "string")
      return JSON.parse(e)?.language;
  }
  return "es";
}, es = (e) => {
  const s = zr(), y = e.toLowerCase(), I = Wr.filter((_t) => _t.keys.some((Fe) => y.includes(Fe)));
  return I.length ? I.map((_t) => _t[s === "es" ? "message-es" : "message-en"]) : s === "es" ? ["Este error no se está manejando."] : ["This error is not being handled."];
}, Jr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getApiMessageError: es
}, Symbol.toStringTag, { value: "Module" })), n = (e, s) => {
  throw new Error(`[QueryModule][${e}]: ${s}`);
}, xr = (e, s) => {
  console.warn(`[QueryModule][${e}]: ${s}`);
}, Zr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  missing: n,
  warn: xr
}, Symbol.toStringTag, { value: "Module" })), qn = (e, s = "filters", y = 0) => {
  const I = (Fe) => `[${Fe}]`;
  return Object.entries(e).map(([Fe, Xs], Kn) => {
    const en = I(Fe);
    return Fe === "$or" || Fe === "$and" ? qn(Xs, `${s}${en}`, Kn) : Object.entries(Xs).map(([wn, Un]) => `${s}${en}${I(`$${wn}`)}${I(y)}=${Un}`).flat().join("&");
  }).flat().join("&");
}, T = (e, s, y = "filters") => `${e}?${qn(s, y)}`, Vi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ApiUtils: Jr,
  WarnUtils: Zr,
  generateFilter: T
}, Symbol.toStringTag, { value: "Module" })), $n = process.env.NUBETECK_SERVER_URL ?? "";
if (!$n)
  throw new Error("Please add your Server URL to environment variables.");
const t = (e) => {
  const s = localStorage.getItem("token"), y = Yn.create({
    params: e,
    timeout: 1e6,
    baseURL: $n,
    headers: { Authorization: `Bearer ${s}` }
  });
  return y.interceptors.response.use((I) => I, (I) => I.response ? Promise.reject(es(I.response.data?.Result?.OuterException ?? "").join(" ")) : Promise.reject(es(I.message).join(""))), y;
}, Dt = {
  login: async (e) => (e || n(nn, "Missing values"), (await t().post(nn, e)).data.Result),
  refreshToken: async (e) => (e || n(rn, "Missing token"), (await t().post(rn, { Token: e })).data.Result),
  changePassword: async (e) => (e.OldPassword || n(Ot, "Missing old password"), e.NewPassword || n(Ot, "Missing new password"), e.ConfirmNewPassword || n(Ot, "Missing confirm password"), (await t().post(Ot, e)).data.Result)
}, ze = {
  getAll: async () => (await t().get(Ae)).data.Result,
  create: async (e) => (await t().post(Ae, e)).data.Result,
  delete: async (e) => {
    e || n(Ae, "Missing delete ID"), await t().put(`${Ae}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(Ae, "Missing ID"), (await t().get(`${Ae}/${e}`)).data.Result),
  update: async (e) => (e.BancoId || n(Ae, "Missing update ID"), (await t().put(`${Ae}/${e.BancoId}`, e)).data.Result)
}, At = {
  getAll: async () => (await t().get(Qe)).data.Result,
  create: async (e) => (await t().post(Qe, e)).data.Result,
  getById: async (e) => (e || n(Qe, "Missing ID"), (await t().get(`${Qe}/${e}`)).data.Result),
  update: async (e) => (e.ImpuestoId || n(Qe, "Missing update ID"), (await t().put(`${Qe}/${e.ImpuestoId}`, e)).data.Result)
}, ge = {
  getAll: async () => (await t().get(Me)).data.Result,
  getAllNames: async () => (await t().post(jr)).data.Result,
  getById: async (e) => (await t().get(`${Me}/${e}`)).data.Result,
  create: async (e) => (await t().post(br, e)).data.Result,
  getMe: async () => (await t().post(Qr)).data.Result?.[0] ?? {},
  getAllPermissions: async (e) => (await t().post(Hr, {
    ModuloId: e
  })).data.Result,
  update: async (e) => (e.UserId || n(Me, "Missing update ID"), (await t().put(`${Me}/${e.UserId}`, e)).data.Result)
}, Je = {
  getAll: async () => (await t().get(He)).data.Result,
  create: async (e) => (await t().post(He, e)).data.Result,
  getAllByUser: async (e) => (await t().post(kr, { userId: e })).data.Result,
  getById: async (e) => (e || n(He, "Missing ID"), (await t().get(`${He}/${e}`)).data.Result),
  update: async (e) => (e.RolId || n(He, "Missing update ID"), (await t().put(`${He}/${e.RolId}`)).data.Result)
}, $s = {
  getAll: async () => (await t().get(Xt)).data.Result,
  getById: async (e) => (e || n(Xt, "Missing ID"), (await t().get(`${Xt}/${e}`)).data.Result)
}, ms = {
  getAll: async () => (await t().get(xt)).data.Result,
  getById: async (e) => (e || n(xt, "Missing ID"), (await t().get(`${xt}/${e}`)).data.Result)
}, Ms = {
  getAll: async () => (await t().get(ln)).data.Result,
  getById: async (e) => {
    if (!e)
      throw new Error("Missing module id");
    return (await t().get(`${ln}/${e}`)).data.Result;
  }
}, Kt = {
  getAll: async () => (await t().post(Pn)).data.Result,
  getAllProc: async () => (await t().post(Yr)).data.Result
}, xe = {
  create: async (e) => (await t().post(J, e)).data.Result,
  delete: async (e) => {
    e || n(J, "Missing delete ID"), await t().put(`${J}/${e}`, {
      EstadoId: o
    });
  },
  getAll: async () => (await t().get(T(J, {
    EstadoId: { ne: o }
  }))).data.Result,
  getById: async (e) => (e || n(J, "Missing ID"), (await t().get(`${J}/${e}`)).data.Result),
  update: async (e) => (e.ClienteEmpresaPropiaId || n(J, "Missing update ID"), (await t().put(`${J}/${e.ClienteEmpresaPropiaId}`, e)).data.Result)
}, Ds = {
  getAll: async () => (await t().get(ht)).data.Result,
  getById: async (e) => (e || n(ht, "Missing ID"), (await t().get(`${ht}/${e}`)).data.Result)
}, Ze = {
  getAll: async () => (await t().get(p)).data.Result,
  getById: async (e) => (await t().get(`${p}/${e}`)).data.Result,
  create: async (e) => (await t().post(p, e)).data.Result,
  delete: async (e) => {
    e || n(p, "Missing ID"), await t().put(`${p}/${e}`, {
      EstadoId: o
    });
  },
  update: async (e) => (e.PaisProvinciaMunicipioSectorId || n(p, "Missing province ID"), (await t().put(`${p}/${e.PaisProvinciaMunicipioSectorId}`, e)).data.Result),
  getAllByMunicipalityId: async (e) => (e || n(p, "Missing municipality ID"), (await t().get(T(p, {
    PaisProvinciaMunicipioId: { eq: e }
  }))).data.Result)
}, Ks = {
  getAll: async () => (await t().get(ye)).data.Result,
  create: async (e) => (await t().post(ye, e)).data.Result,
  delete: async (e) => {
    e || n(ye, "Missing delete ID"), await t().delete(`${ye}/${e}`);
  },
  getById: async (e) => (e || n(ye, "Missing ID"), (await t().get(`${ye}/${e}`)).data.Result),
  update: async (e) => (e.FinanciamientoId || n(ye, "Missing update ID"), (await t().put(`${ye}/${e.FinanciamientoId}`, e)).data.Result)
}, ws = {
  getAll: async () => (await t().get(zt)).data.Result,
  getById: async (e) => (e || n(zt, "Missing ID"), (await t().get(`${zt}/${e}`)).data.Result)
}, wt = {
  getAll: async () => (await t().get(St)).data.Result,
  getAllProc: async () => (await t().post(hr)).data.Result,
  getProductByCode: async (e) => (await t().post(Lr, {
    Codigo: e
  })).data.Result,
  getById: async (e) => (e || n(St, "Missing ID"), (await t().get(`${St}/${e}`)).data.Result)
}, Us = {
  getAll: async () => (await t().get(tn)).data.Result,
  getById: async (e) => (await t().get(`${tn}/${e}`)).data.Result
}, Xe = {
  create: async (e) => (await t().post(Ee, e)).data.Result,
  getAll: async () => (await t().get(T(Ee, { EstadoId: { ne: 15 } }))).data.Result,
  getById: async (e) => (e || n(Ee, "Missing ID"), (await t().get(`${Ee}/${e}`)).data.Result),
  delete: async (e) => {
    e || n(Ee, "Missing delete ID"), await t().put(`${Ee}/${e}`, {
      EstadoId: o
    });
  },
  update: async (e) => (e.PlantillaId || n(Ee, "Missing update ID"), (await t().put(`${Ee}/${e.PlantillaId}`, e)).data.Result)
}, et = {
  getAll: async () => (await t().get(Ne)).data.Result,
  create: async (e) => (await t().post(Ne, e)).data.Result,
  delete: async (e) => {
    e || n(Ne, "Missing delete ID"), await t().put(`${Ne}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(Ne, "Missing ID"), (await t().get(`${Ne}/${e}`)).data.Result),
  update: async (e) => (e.PaisId || n(Ne, "Missing update ID"), (await t().put(`${Ne}/${e.PaisId}`, e)).data.Result)
}, tt = {
  getAll: async () => (await t().get(Ce)).data.Result,
  create: async (e) => (await t().post(Ce, e)).data.Result,
  delete: async (e) => {
    e || n(Ce, "Missing delete ID"), await t().put(`${Ce}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(Ce, "Missing ID"), (await t().get(`${Ce}/${e}`)).data.Result),
  update: async (e) => (e.DocumentoId || n(Ce, "Missing update ID"), (await t().put(`${Ce}/${e.DocumentoId}`, e)).data.Result)
}, fe = {
  getAll: async () => (await t().get(A)).data.Result,
  create: async (e) => (await t().post(A, e)).data.Result,
  delete: async (e) => {
    e || n(A, "Missing ID"), await t().put(`${A}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(A, "Missing ID"), (await t().get(`${A}/${e}`)).data.Result),
  update: async (e) => (e.PaisProvinciaId || n(A, "Missing province ID"), (await t().put(`${A}/${e.PaisProvinciaId}`, e)).data.Result),
  getAllByCountryId: async (e) => (e || n(A, "Missing country ID"), (await t().get(T(A, {
    PaisId: { eq: e }
  }))).data.Result)
}, Le = {
  getAll: async () => (await t().get(Se)).data.Result,
  create: async (e) => (await t().post(Se, e)).data.Result,
  switchMain: async (e) => {
    e || n(cn, "Missing switch ID"), await t().post(cn, { MonedaId: e });
  },
  delete: async (e) => {
    e || n(Se, "Missing delete ID"), await t().put(`${Se}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(Se, "Missing ID"), (await t().get(`${Se}/${e}`)).data.Result),
  update: async (e) => (e.MonedaId || n(Se, "Missing update ID"), (await t().put(`${Se}/${e.MonedaId}`, e)).data.Result)
}, Ut = {
  getAll: async () => (await t().get(Jt)).data.Result,
  create: async (e) => (await t().post(qe, e)).data.Result,
  getById: async (e) => (e || n(Jt, "Missing ID"), (await t().get(`${Jt}/${e}`)).data.Result),
  delete: async (e) => {
    e || n(qe, "Missing delete ID"), await t().put(`${qe}/${e}`, {
      EstadoId: o
    });
  },
  getByProductId: async (e) => (e || n(qe, "Missing product ID"), (await t().get(T(qe, {
    ProductoId: { eq: e }
  }))).data.Result),
  update: async (e) => (e.AlmacenId || n(qe, "Missing update ID"), (await t().put(`${qe}/${e.AlmacenId}`, e)).data.Result)
}, Ys = {
  getAll: async () => (await t().get(Gt)).data.Result,
  getById: async (e) => (e || n(Gt, "Missing ID"), (await t().get(`${Gt}/${e}`)).data.Result)
}, hs = {
  getAll: async () => (await t().get(Zt)).data.Result,
  getById: async (e) => (e || n(Zt, "Missing ID"), (await t().get(`${Zt}/${e}`)).data.Result)
}, st = {
  getAll: async () => (await t().get(W)).data.Result,
  create: async (e) => (await t().post(W, e)).data.Result,
  getById: async (e) => (e || n(W, "Missing ID"), (await t().get(`${W}/${e}`)).data.Result),
  delete: async (e) => (e || n(W, "Missing delete ID"), (await t().put(`${W}/${e}`, { EstadoId: o })).data.Result),
  update: async (e) => (e.ContactoTipoDireccionId || n(W, "Missing update ID"), (await t().put(`${W}/${e.ContactoTipoDireccionId}`, e)).data.Result)
}, fs = {
  getAll: async () => (await t().get(Yt)).data.Result,
  getById: async (e) => (e || n(Yt, "Missing ID"), (await t().get(`${Yt}/${e}`)).data.Result)
}, nt = {
  create: async (e) => (await t().post(z, e)).data.Result,
  delete: async (e) => {
    e || n(z, "Missing delete ID"), await t().put(`${z}/${e}`, {
      EstadoId: o
    });
  },
  getAll: async () => (await t().get(T(z, {
    EstadoId: { ne: o }
  }))).data.Result,
  getById: async (e) => (e || n(z, "Missing ID"), (await t().get(`${z}/${e}`)).data.Result),
  update: async (e) => (e.ClienteEmpresaPropiaTipoEmpresaId || n(z, "Missing update ID"), (await t().put(`${z}/${e.ClienteEmpresaPropiaTipoEmpresaId}`, e)).data.Result)
}, ts = {
  getAll: async () => (await t().get(ft)).data.Result,
  getById: async (e) => (e || n(ft, "Missing ID"), (await t().get(T(ft, {
    ContactoId: { eq: e }
  }))).data.Result[0]),
  getContactPhoto: async (e) => (e || n(sn, "Missing contact ID"), (await t().post(sn, {
    ContactoId: e
  })).data.Result[0] ?? null)
}, rt = {
  getAll: async () => (await t().get(te)).data.Result,
  create: async (e) => (await t().post(te, e)).data.Result,
  delete: async (e) => {
    e || n(te, "Missing delete ID"), await t().put(`${te}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(te, "Missing ID"), (await t().get(`${te}/${e}`)).data.Result),
  update: async (e) => (e.ContactoTipoId || n(te, "Missing update ID"), (await t().put(`${te}/${e.ContactoTipoId}`, e)).data.Result)
}, Nt = {
  getAll: async () => (await t().get(Te)).data.Result,
  delete: async (e) => {
    e || n(Te, "Missing delete ID"), await t().delete(`${Te}/${e}`);
  },
  create: async (e) => (await t().post(Te, e)).data.Result,
  getById: async (e) => (e || n(Te, "Missing ID"), (await t().get(`${Te}/${e}`)).data.Result),
  update: async (e) => (e.FinanciamientoGrupoId || n(Te, "Missing update ID"), (await t().put(`${Te}/${e.FinanciamientoGrupoId}`, e)).data.Result)
}, ut = {
  getAll: async () => (await t().get(Z)).data.Result,
  create: async (e) => (await t().post(Z, e)).data.Result,
  delete: async (e) => {
    e || n(Z, "Missing delete ID"), await t().put(`${Z}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(Z, "Missing ID"), (await t().get(`${Z}/${e}`)).data.Result),
  update: async (e) => (e.ClienteNacionalidadId || n(Z, "Missing update ID"), (await t().put(`${Z}/${e.ClienteNacionalidadId}`, e)).data.Result)
}, at = {
  getAll: async () => (await t().get(x)).data.Result,
  create: async (e) => (await t().post(x, e)).data.Result,
  delete: async (e) => {
    e || n(x, "Missing delete ID"), await t().put(`${x}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(x, "Missing ID"), (await t().get(`${x}/${e}`)).data.Result),
  update: async (e) => (e.ClienteTipoEstadoCivilId || n(x, "Missing update ID"), (await t().put(`${x}/${e.ClienteTipoEstadoCivilId}`, e)).data.Result)
}, ot = {
  getAll: async () => (await t().get(Ie)).data.Result,
  create: async (e) => (await t().post(`${Ie}`, e)).data.Result,
  delete: async (e) => {
    e || n(Ie, "Missing delete ID"), await t().delete(`${Ie}/${e}`);
  },
  getById: async (e) => (e || n(Ie, "Missing ID"), (await t().get(`${Ie}/${e}`)).data.Result),
  update: async (e) => (e.ReengancheId || n(Ie, "Missing update ID"), (await t().put(`${Ie}/${e.ReengancheId}`, e)).data.Result)
}, Ve = {
  getAll: async () => (await t().get(N)).data.Result,
  create: async (e) => (await t().post(N, e)).data.Result,
  delete: async (e) => {
    e || n(N, "Missing delete ID"), await t().put(`${N}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(N, "Missing ID"), (await t().get(`${N}/${e}`)).data.Result),
  update: async (e) => (e.PaisProvinciaMunicipioId || n(N, "Missing update ID"), (await t().put(`${N}/${e.PaisProvinciaMunicipioId}`, e)).data.Result),
  getAllByProvinceId: async (e) => (e || n(N, "Missing province ID"), (await t().get(T(N, {
    EstadoId: { ne: 15 },
    $and: { PaisProvinciaId: { eq: e } }
  }))).data.Result)
}, ct = {
  create: async (e) => (await t().post(de, e)).data.Result,
  getAll: async () => (await t().get(T(de, { EstadoId: { ne: 15 } }))).data.Result,
  delete: async (e) => {
    e || n(de, "Missing delete ID"), await t().put(`${de}/${e}`, {
      EstadoId: 15
    });
  },
  getById: async (e) => (e || n(de, "Missing ID"), (await t().get(`${de}/${e}`)).data.Result),
  update: async (e) => (e.TipoPlantillaId || n(de, "Missing update ID"), (await t().put(`${de}/${e.TipoPlantillaId}`, e)).data.Result)
}, it = {
  create: async (e) => (await t().post(j, e)).data.Result,
  getAll: async () => (await t().get(T(j, {
    EstadoId: { ne: o }
  }))).data.Result,
  getById: async (e) => (e || n(j, "Missing ID"), (await t().get(`${j}/${e}`)).data.Result),
  delete: async (e) => {
    e || n(j, "Missing delete ID"), await t().put(`${j}/${e}`, {
      EstadoId: o
    });
  },
  update: async (e) => (e.ClienteDatoLaboralEmpresaId || n(j, "Missing update ID"), (await t().put(`${j}/${e.ClienteDatoLaboralEmpresaId}`, e)).data.Result)
}, Ls = {
  getAll: async () => (await t().get(Lt)).data.Result,
  getById: async (e) => (e || n(Lt, "Missing ID"), (await t().get(`${Lt}/${e}`)).data.Result)
}, _e = {
  getAll: async () => (await t().get(me)).data.Result,
  getByTag: async (e) => (await t().get(T(me, {
    Campo: { eq: e }
  }))).data.Result[0],
  getById: async (e) => (e || n(me, "Missing ID"), (await t().get(`${me}/${e}`)).data.Result),
  updateAllSettings: async (e) => {
    e.length || n(an, "Missing all settings"), await t().post(an, {
      Configuraciones: e
    });
  },
  getAllProc: async (e) => (e || n(un, "Missing category ID"), (await t().post(`${un}/${e}`)).data.Result),
  update: async (e) => (e.ConfiguracionId || n(me, "Missing update ID"), (await t().put(`${me}/${e.ConfiguracionId}`, e)).data.Result)
}, lt = {
  getAll: async () => (await t().get(X)).data.Result,
  create: async (e) => (await t().post(X, e)).data.Result,
  getById: async (e) => (e || n(X, "Missing ID"), (await t().get(`${X}/${e}`)).data.Result),
  delete: async (e) => {
    e || n(X, "Missing delete ID"), await t().put(`${X}/${e}`, {
      EstadoId: o
    });
  },
  update: async (e) => (e.ClienteTipoOcupacionId || n(X, "Missing update ID"), (await t().put(`${X}/${e.ClienteTipoOcupacionId}`, e)).data.Result)
}, yt = {
  getAll: async () => (await t().get(ee)).data.Result,
  create: async (e) => (await t().post(ee, e)).data.Result,
  delete: async (e) => {
    e || n(ee, "Missing delete ID"), await t().put(`${ee}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(ee, "Missing ID"), (await t().get(`${ee}/${e}`)).data.Result),
  update: async (e) => (e.ClienteTipoProfesionId || n(ee, "Missing update ID"), (await t().put(`${ee}/${e.ClienteTipoProfesionId}`, e)).data.Result)
}, mn = {
  getAll: async () => [],
  create: async (e) => (await t().post($e, e)).data.Result,
  delete: async (e) => {
    e || n($e, "Missing delete ID"), await t().delete(`${$e}/${e}`);
  },
  getById: async (e) => (e || n($e, "Missing ID"), (await t().get(`${$e}/${e}`)).data.Result),
  update: async (e) => (e.FinanciamientoId || n($e, "Missing update ID"), (await t().put(`${$e}/${e.FinanciamientoId}`, e)).data.Result)
}, Vs = {
  getAll: async () => (await t().get(jt)).data.Result,
  getById: async (e) => (e || n(jt, "Missing ID"), (await t().get(`${jt}/${e}`)).data.Result)
}, Xr = {
  getAll: async () => (await t().get(ae)).data.Result,
  create: async (e) => (await t().post(ae, e)).data.Result,
  getById: async (e) => (e || n(ae, "Missing ID"), (await t().get(`${ae}/${e}`)).data.Result),
  delete: async (e) => {
    e || n(ae, "Missing delete ID"), await t().put(`${ae}/${e}`, {
      EstadoId: o
    });
  },
  update: async (e) => (e.VehiculosCondicionId || n(ae, "Missing update ID"), (await t().put(`${ae}/${e.VehiculosCondicionId}`, e)).data.Result)
}, Oe = {
  getAll: async () => (await t().post(C)).data.Result,
  getAllProc: async () => (await t().post(Br)).data.Result,
  create: async (e) => (await t().post(C, e)).data.Result,
  getById: async (e) => (e || n(C, "Missing ID"), (await t().get(`${C}/${e}`)).data.Result),
  delete: async (e) => {
    e || n(C, "Missing delete ID"), await t().put(`${C}/${e}`, {
      EstadoId: o
    });
  },
  activate: async (e) => {
    e || n(C, "Missing activate ID"), await t().put(`${C}/${e}`, {
      EstadoId: qs
    });
  },
  update: async (e) => (e.TransferenciaId || n(C, "Missing update ID"), (await t().put(`${C}/${e.TransferenciaId}`, e)).data.Result)
}, Ue = {
  getAll: async () => (await t().get(se)).data.Result,
  create: async (e) => (await t().post(se, e)).data.Result,
  getById: async (e) => (e || n(se, "Missing ID"), (await t().get(`${se}/${e}`)).data.Result),
  delete: async (e) => {
    e || n(se, "Missing delete ID"), await t().put(`${se}/${e}`, {
      EstadoId: o
    });
  },
  update: async (e) => (e.ProductoMarcaId || n(se, "Missing update ID"), (await t().put(`${se}/${e.ProductoMarcaId}`, e)).data.Result)
}, Tt = {
  getAll: async () => (await t().get(Pe)).data.Result,
  getById: async (e) => (await t().get(`${Pe}/${e}`)).data.Result,
  create: async (e) => (await t().post(Pe, e)).data.Result,
  delete: async (e) => {
    e || n(Pe, "Missing delete ID"), await t().put(`${Pe}/${e}`, {
      EstadoId: o
    });
  },
  update: async (e) => (e.ClienteTipoParentescosId || n(Pe, "Missing update ID"), (await t().put(`${Pe}/${e.ClienteTipoParentescosId}`, e)).data.Result)
}, vs = {
  create: async (e) => (await t().post(k, e)).data.Result,
  getAll: async () => (await t().get(T(k, {
    EstadoId: { ne: o }
  }))).data.Result,
  getById: async (e) => (e || n(k, "Missing ID"), (await t().get(`${k}/${e}`)).data.Result),
  delete: async (e) => (e || n(k, "Missing delete ID"), (await t().put(`${k}/${e}`, { EstadoId: o })).data.Result),
  update: async (e) => (e.ClienteTipoNivelAcademicoId || n(k, "Missing update ID"), (await t().put(`${k}/${e.ClienteTipoNivelAcademicoId}`, e)).data.Result)
}, Bs = {
  getAll: async () => (await t().get(bt)).data.Result,
  getById: async (e) => (e || n(bt, "Missing ID"), (await t().get(`${bt}/${e}`)).data.Result)
}, Gs = {
  getAll: async () => (await t().get(Ht)).data.Result,
  getById: async (e) => (e || n(Ht, "Missing ID"), (await t().get(`${Ht}/${e}`)).data.Result)
}, pe = {
  getAllProc: async () => (await t().post(Vr)).data.Result,
  create: async (e) => (await t().post(d, e)).data.Result,
  getAll: async () => (await t().post(T(d, {
    EstadoId: { ne: o }
  }))).data.Result,
  delete: async (e) => {
    e || n(d, "Missing delete ID"), await t().put(`${d}/${e}`, {
      EstadoId: o
    });
  },
  activate: async (e) => {
    e || n(d, "Missing activate ID"), await t().put(`${d}/${e}`, {
      EstadoId: qs
    });
  },
  getById: async (e) => (e || n(d, "Missing ID"), (await t().get(`${d}/${e}`)).data.Result),
  update: async (e) => (e.InventarioAjusteId || n(d, "Missing update ID"), (await t().put(`${d}/${e.InventarioAjusteId}`, e)).data.Result)
}, Ft = {
  getAll: async () => (await t().get(ue)).data.Result,
  create: async (e) => (await t().post(ue, e)).data.Result,
  getById: async (e) => (e || n(ue, "Missing ID"), (await t().get(`${ue}/${e}`)).data.Result),
  delete: async (e) => {
    e || n(ue, "Missing delete ID"), await t().put(`${ue}/${e}`, {
      EstadoId: o
    });
  },
  update: async (e) => (e.VehiculoCilindroId || n(ue, "Missing update ID"), (await t().put(`${ue}/${e.VehiculoCilindroId}`, e)).data.Result)
}, bs = {
  getAll: async () => (await t().get(Be)).data.Result,
  create: async (e) => (await t().post(Be, e)).data.Result,
  getById: async (e) => (e || n(Be, "Missing ID"), (await t().get(`${Be}/${e}`)).data.Result),
  update: async (e) => (e.ProductoTipoUnidadMedidaId || n(Be, "Missing update ID"), (await t().put(`${Be}/${e.ProductoTipoUnidadMedidaId}`, e)).data.Result)
}, Qs = {
  getAll: async () => (await t().get(Qt)).data.Result,
  getById: async (e) => (e || n(Qt, "Missing ID"), (await t().get(`${Qt}/${e}`)).data.Result)
}, Hs = {
  getAll: async () => (await t().get(Vt)).data.Result,
  getById: async (e) => (e || n(Vt, "Missing ID"), (await t().get(`${Vt}/${e}`)).data.Result)
}, Rt = {
  create: async (e) => (await t().post(pt, e)).data.Result,
  getAll: async (e) => (await t().get(T(pt, {
    ProductoId: { eq: e }
  }))).data.Result,
  delete: async ({ productId: e, sucursalId: s, priceListId: y }) => {
    e || n(O, "Missing product ID"), y || n(O, "Missing price list ID"), s || n(O, "Missing succursal ID"), await t().post(fr, {
      ProductoId: e,
      SucursalId: s,
      ListaPrecioId: y
    });
  },
  update: async (e) => (e.ProductoId || n(O, "Missing product ID"), e.ListaPrecioId || n(O, "Missing price list ID"), e.SucursalId || n(O, "Missing succursal ID"), e.PrecioVenta || n(O, "Missing sale price ID"), e.PrecioVentaMinimo || n(O, "Missing sale price minimum ID"), (await t().post(`${O}`, {
    ProductoId: e.ProductoId,
    SucursalId: e.SucursalId,
    PrecioVenta: e.PrecioVenta,
    ListaPrecioId: e.ListaPrecioId,
    PrecioVentaMinimo: e.PrecioVentaMinimo
  })).data.Result)
}, js = {
  getAll: async () => (await t().get(on)).data.Result,
  getById: async (e) => (e || n(me, "Missing ID"), (await t().get(`${on}/${e}`)).data.Result)
}, ks = {
  getAll: async () => (await t().get(kt)).data.Result,
  getById: async (e) => (e || n(kt, "Missing ID"), (await t().get(`${kt}/${e}`)).data.Result)
}, Mn = {
  getAll: async () => [],
  create: async (e) => (await t().post(Ct, e)).data.Result,
  delete: async (e) => {
    e || n(Ct, "Missing delete ID"), await t().delete(`${Ct}/${e}`);
  },
  getById: async (e) => (e || n(Ct, "Missing ID"), (await t().get(`${Ct}/${e}`)).data.Result)
}, Ws = {
  getAll: async () => (await t().get(ve)).data.Result,
  create: async (e) => (await t().post(ve, e)).data.Result,
  getById: async (e) => (e || n(ve, "Missing ID"), (await t().get(`${ve}/${e}`)).data.Result),
  update: async (e) => (e.ProductoCalidadId || n(ve, "Missing update ID"), (await t().put(`${ve}/${e.ProductoCalidadId}`, e)).data.Result)
}, eu = {
  getAll: async () => (await t().get(ie)).data.Result,
  create: async (e) => (await t().post(ie, e)).data.Result,
  delete: async (e) => {
    e || n(ie, "Missing delete ID"), await t().put(`${ie}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(ie, "Missing ID"), (await t().get(`${ie}/${e}`)).data.Result),
  update: async (e) => (e.VehiculoTipoCapacidadCargaId || n(ie, "Missing update ID"), (await t().put(`${ie}/${e.VehiculoTipoCapacidadCargaId}`, e)).data.Result)
}, Ye = {
  getAll: async () => (await t().get(oe)).data.Result,
  create: async (e) => (await t().post(oe, e)).data.Result,
  delete: async (e) => {
    e || n(oe, "Missing delete ID"), await t().put(`${oe}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(oe, "Missing ID"), (await t().get(`${oe}/${e}`)).data.Result),
  update: async (e) => (e.VehiculoTipoCombustibleId || n(oe, "Missing update ID"), (await t().put(`${oe}/${e.VehiculoTipoCombustibleId}`, e)).data.Result)
}, zs = {
  create: async (e) => (await t().post(ce, e)).data.Result,
  getAll: async () => (await t().get(ce)).data.Result,
  delete: async (e) => {
    e || n(ce, "Missing delete ID"), await t().put(`${ce}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(ce, "Missing ID"), (await t().get(`${ce}/${e}`)).data.Result),
  update: async (e) => (e.VehiculoTipoTransmisionId || n(ce, "Missing update ID"), (await t().put(`${ce}/${e.VehiculoTipoTransmisionId}`, e)).data.Result)
}, tu = (e, s) => e ? !s || s.length === 0 ? e : s.reduce(
  (y, I) => (delete y[I], y),
  { ...e }
) : {}, gt = {
  getAll: async () => (await t().get(je)).data.Result,
  calculate: async (e = 0) => (await t().post(Gr, { Numero: e })).data.Result,
  getById: async (e) => (e || n(je, "Missing ID"), (await t().get(`${je}/${e}`)).data.Result),
  update: async (e) => (e.FinanciamientoTipoConceptoGastoCierreId || n(je, "Missing update ID"), (await t().put(`${je}/${e.FinanciamientoTipoConceptoGastoCierreId}`, tu(e, ["FinanciamientoTipoConceptoGastoCierreId"]))).data.Result)
}, Js = {
  getAll: async () => (await t().get(Bt)).data.Result,
  getById: async (e) => (e || n(Bt, "Missing ID"), (await t().get(`${Bt}/${e}`)).data.Result)
}, xs = {
  getAll: async () => (await t().get(Wt)).data.Result,
  getById: async (e) => (e || n(Wt, "Missing ID"), (await t().get(`${Wt}/${e}`)).data.Result)
}, It = {
  getAll: async () => (await t().get(ne)).data.Result,
  create: async (e) => (await t().post(ne, e)).data.Result,
  getById: async (e) => (e || n(ne, "Missing ID"), (await t().get(`${ne}/${e}`)).data.Result),
  delete: async (e) => {
    e || n(ne, "Missing delete ID"), await t().put(`${ne}/${e}`, {
      EstadoId: o
    });
  },
  update: async (e) => (e.ProductoCategoriaId || n(ne, "Missing update ID"), (await t().put(`${ne}/${e.ProductoCategoriaId}`, e)).data.Result)
}, Zs = {
  getAll: async () => (await t().get(vt)).data.Result,
  getById: async (e) => (e || n(vt, "Missing ID"), (await t().get(`${vt}/${e}`)).data.Result)
}, su = {
  create: async (e) => (await t().post(Ge, e)).data.Result,
  getAll: async () => (await t().get(Ge)).data.Result,
  delete: async (e) => {
    e || n(Ge, "Missing delete ID"), await t().put(`${Ge}/${e}`, { EstadoId: o });
  },
  update: async (e) => (e.VehiculoAccesorioCategoriaId || n(Ge, "Missing update ID"), (await t().put(`${Ge}/${e.VehiculoAccesorioCategoriaId}`, e)).data.Result)
}, Et = {
  getAll: async () => (await t().get(le)).data.Result,
  create: async (e) => (await t().post(le, e)).data.Result,
  delete: async (e) => {
    e || n(le, "Missing delete ID"), await t().put(`${le}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(le, "Missing ID"), (await t().get(`${le}/${e}`)).data.Result),
  update: async (e) => (e.ProductoTipoRazonAjusteId || n(le, "Missing update ID"), (await t().put(`${le}/${e.ProductoTipoRazonAjusteId}`, e)).data.Result)
}, Dn = {
  getAll: async () => (await t().get(vr)).data.Result
}, dt = {
  getAll: async () => (await t().get(re)).data.Result,
  create: async (e) => (await t().post(re, e)).data.Result,
  delete: async (e) => {
    e || n(re, "Missing delete ID"), await t().put(`${re}/${e}`, {
      EstadoId: o
    });
  },
  getById: async (e) => (e || n(re, "Missing ID"), (await t().get(`${re}/${e}`)).data.Result),
  update: async (e) => (e.ProductoMarcaModeloId || n(re, "Missing update ID"), (await t().put(`${re}/${e?.ProductoMarcaModeloId}`, e)).data.Result)
}, nu = {
  create: async (e) => (await t().post(be, e)).data.Result,
  getAll: async () => (await t().get(be)).data.Result,
  delete: async (e) => {
    e || n(be, "Missing delete ID"), await t().put(`${be}/${e}`, { EstadoId: o });
  },
  update: async (e) => (e.CategoriaAccesorioId || n(be, "Missing update ID"), (await t().put(`${be}/${e.CategoriaAccesorioId}`, e)).data.Result)
}, vi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AcademicLevelTypesApi: vs,
  AccountTypesApi: fs,
  AccountsApi: ws,
  AddressTypeApi: st,
  AuthApi: Dt,
  BankApi: ze,
  ClientsApi: Kt,
  ClientsCompanyApi: it,
  CompanyApi: xe,
  CompanyTypesApi: nt,
  ContactFilesApi: ts,
  ContactTypeDniApi: Ls,
  ContactTypesApi: rt,
  ContactsApi: Us,
  ContactsFilesApi: ts,
  CountriesApi: et,
  CurrenciesApi: Le,
  DocumentsApi: tt,
  FamilyRelationshipApi: Tt,
  FinanceAmortizationApi: Bs,
  FinanceApi: Ks,
  FinanceAssuranceApi: mn,
  FinanceAssuranceProductApi: Mn,
  FinanceAssuranceTypesApi: Gs,
  FinanceGroupApi: Nt,
  FinanceLatePaymentCalcApi: ks,
  FinanceRehookApi: ot,
  FinanceTypeApi: Ys,
  FinanceTypeConceptsClosingApi: gt,
  FinancesMethodPaymentApi: Qs,
  FrequencyPaymentApi: Vs,
  GendersApi: Ds,
  GeneralSettingsApi: _e,
  GeneralSettingsCategoriesApi: xs,
  GeneralSettingsOptionsApi: js,
  InventoryAdjustmentsApi: pe,
  InventoryAdjustmentsDetailsApi: Dn,
  InventoryAdjustmentsReasonsApi: Et,
  InventoryProductListPriceApi: Zs,
  InventoryProductPriceApi: Rt,
  InventoryProductsBrandApi: Ue,
  InventoryProductsBrandModelApi: dt,
  InventoryProductsCategoryApi: It,
  InventoryProductsQualityApi: Ws,
  InventoryProductsTypeApi: Hs,
  InventoryProductsUnitApi: bs,
  InventoryTransfersApi: Oe,
  InventoryTransfersDetailsApi: Js,
  InventoryVehicleCylindersApi: Ft,
  InventoryVehicleTransmissionsApi: Ye,
  InventoryVehicleTypeFuelApi: Ye,
  MaritalStatusApi: at,
  ModulesApi: Ms,
  MonthsApi: $s,
  MunicipalitiesApi: Ve,
  NationalitiesApi: ut,
  OccupationsTypesApi: lt,
  ProductsApi: wt,
  ProductsBrandApi: Ue,
  ProfessionsTypesApi: yt,
  ProvincesApi: fe,
  RolesApi: Je,
  SectorsApi: Ze,
  StatusApi: ms,
  TaxesApi: At,
  TemplatesApi: Xe,
  TemplatesTypesApi: ct,
  UsersApi: ge,
  VehicleAccessoryCategoriesApi: su,
  VehicleAccessoryCategoryTypeApi: nu,
  VehicleConditionsApi: Xr,
  VehicleCylindersApi: Ft,
  VehicleLoadingCapacitiesApi: eu,
  VehicleTransmissionsApi: zs,
  VoucherTypeApi: hs,
  WarehousesApi: Ut
}, Symbol.toStringTag, { value: "Module" })), ru = () => r({
  queryKey: [Q],
  queryFn: ze.getAll
}), uu = (e) => r({
  enabled: !!e,
  queryKey: [Q, e],
  queryFn: () => ze.getById?.(e)
}), au = () => r({
  queryKey: [Ke],
  queryFn: ge.getAll
}), ou = (e) => r({
  enabled: !!e,
  queryKey: [Ke, e],
  queryFn: () => ge.getById?.(e)
}), cu = (e) => r({
  queryFn: ge.getMe,
  queryKey: [Sn],
  ...e
}), iu = (e, s) => r({
  queryKey: [An, e],
  queryFn: () => ge.getAllPermissions(e),
  ...s
}), lu = () => r({
  queryKey: [Rn],
  queryFn: ge.getAllNames
}), yu = () => r({
  queryKey: [we],
  queryFn: At.getAll
}), Tu = (e) => r({
  enabled: !!e,
  queryKey: [we, e],
  queryFn: () => At.getById?.(e)
}), Iu = () => r({
  queryKey: [We],
  queryFn: Je.getAll
}), Eu = (e) => r({
  enabled: !!e,
  queryKey: [We, e],
  queryFn: () => Je.getById?.(e)
}), du = (e) => r({
  enabled: !!e,
  queryKey: [We, e],
  queryFn: () => Je.getAllByUser(e)
}), Cu = () => r({
  queryKey: [Os],
  queryFn: ms.getAll
}), Su = (e) => r({
  enabled: !!e,
  queryKey: [Os, e],
  queryFn: () => ms.getById?.(e)
}), Au = () => r({
  queryKey: [Fs],
  queryFn: $s.getAll
}), Nu = (e) => r({
  enabled: !!e,
  queryKey: [Fs, e],
  queryFn: () => $s.getById?.(e)
}), Ru = () => r({
  queryKey: [Ps],
  queryFn: Ms.getAll
}), gu = (e) => r({
  enabled: !!e,
  queryKey: [Ps, e],
  queryFn: () => Ms.getById?.(e)
}), _u = () => r({
  queryKey: [H],
  queryFn: Ze.getAll
}), Ou = (e) => r({
  enabled: !!e,
  queryKey: [H, e],
  queryFn: () => Ze.getById?.(e)
}), pu = () => r({
  queryKey: [_s],
  queryFn: ws.getAll
}), Fu = (e) => r({
  enabled: !!e,
  queryKey: [_s, e],
  queryFn: () => ws.getById?.(e)
}), Pu = () => r({
  queryFn: Kt.getAll,
  queryKey: [Pt]
}), qu = () => r({
  queryFn: Kt.getAllProc,
  queryKey: [Pt]
}), $u = (e) => r({
  enabled: !!e,
  queryKey: [Pt, e],
  queryFn: () => Kt.getById?.(e)
}), mu = () => r({
  queryFn: Ds.getAll,
  queryKey: [us]
}), Mu = (e) => r({
  enabled: !!e,
  queryKey: [us, e],
  queryFn: () => Ds.getById?.(e)
}), Du = () => r({
  queryKey: [ss],
  queryFn: Us.getAll
}), Ku = (e) => r({
  enabled: !!e,
  queryKey: [ss, e],
  queryFn: () => Us.getById?.(e)
}), wu = () => r({
  queryKey: [Es],
  queryFn: Ks.getAll
}), Uu = (e) => r({
  enabled: !!e,
  queryKey: [Es, e],
  queryFn: () => Ks.getById?.(e)
}), Yu = () => r({
  queryFn: wt.getAll,
  queryKey: [qt]
}), hu = () => r({
  queryFn: wt.getAllProc,
  queryKey: [Tn]
}), fu = (e) => r({
  enabled: !!e,
  queryKey: [qt, e],
  queryFn: () => wt.getById?.(e)
}), Lu = () => r({
  queryKey: [b],
  queryFn: tt.getAll
}), Vu = (e) => r({
  enabled: !!e,
  gcTime: 1 / 0,
  queryKey: [b, e],
  queryFn: () => tt.getById?.(e)
}), vu = () => r({
  queryKey: [v],
  queryFn: Xe.getAll
}), Bu = (e) => r({
  enabled: !!e,
  queryKey: [v, e],
  queryFn: () => Xe.getById?.(e)
}), Gu = () => r({
  queryKey: [S],
  queryFn: fe.getAll
}), bu = (e) => r({
  enabled: !!e,
  queryKey: [S, e],
  queryFn: () => fe.getById?.(e)
}), Qu = (e) => r({
  enabled: !!e,
  queryKey: [S, g, e],
  queryFn: () => fe.getAllByCountryId(e)
}), Hu = () => r({
  queryFn: xe.getAll,
  queryKey: [$]
}), ju = (e) => r({
  enabled: !!e,
  queryKey: [$, e],
  queryFn: () => xe.getById?.(e)
}), ku = () => r({
  queryKey: [g],
  queryFn: et.getAll
}), Wu = (e) => r({
  enabled: !!e,
  queryKey: [g, e],
  queryFn: () => et.getById?.(e)
}), zu = () => r({
  queryKey: [R],
  queryFn: Le.getAll
}), Ju = (e) => r({
  enabled: !!e,
  queryKey: [R, e],
  queryFn: () => Le.getById?.(e)
}), xu = () => r({
  queryKey: [Mt],
  queryFn: Ut.getAll
}), Zu = (e) => r({
  enabled: !!e,
  queryKey: [Mt, e],
  queryFn: () => Ut.getById?.(e)
}), Xu = (e) => r({
  enabled: !!e,
  queryFn: () => Ut.getByProductId?.(e),
  queryKey: [Mt, qt, e]
}), ea = () => r({
  queryFn: lt.getAll,
  queryKey: [K]
}), ta = (e) => r({
  enabled: !!e,
  queryKey: [K, e],
  queryFn: () => lt.getById?.(e)
}), sa = () => r({
  queryFn: yt.getAll,
  queryKey: [w]
}), na = (e) => r({
  enabled: !!e,
  queryKey: [w, e],
  queryFn: () => yt.getById?.(e)
}), ra = () => r({
  queryFn: fs.getAll,
  queryKey: [rs]
}), ua = (e) => r({
  enabled: !!e,
  queryKey: [rs, e],
  queryFn: () => fs.getById?.(e)
}), aa = () => r({
  queryFn: st.getAll,
  queryKey: [P]
}), oa = (e) => r({
  enabled: !!e,
  queryKey: [P, e],
  queryFn: () => st.getById?.(e)
}), ca = () => r({
  queryFn: nt.getAll,
  queryKey: [q]
}), ia = (e) => r({
  enabled: !!e,
  queryKey: [q, e],
  queryFn: () => nt.getById?.(e)
}), la = () => r({
  queryKey: [ps],
  queryFn: hs.getAll
}), ya = (e) => r({
  enabled: !!e,
  queryKey: [ps, e],
  queryFn: () => hs.getById?.(e)
}), Ta = () => r({
  queryKey: [U],
  queryFn: rt.getAll
}), Ia = (e) => r({
  enabled: !!e,
  queryKey: [U],
  queryFn: () => rt.getById?.(e)
}), Ea = (e) => r({
  enabled: !!e,
  queryKey: [yn, e],
  queryFn: () => ts.getContactPhoto(e)
}), da = () => r({
  queryKey: [B],
  queryFn: ct.getAll
}), Ca = (e) => r({
  enabled: !!e,
  queryKey: [B, e],
  queryFn: () => ct.getById?.(e)
}), Sa = () => r({
  queryKey: [De],
  queryFn: Nt.getAll
}), Aa = (e) => r({
  enabled: !!e,
  queryKey: [De, e],
  queryFn: () => Nt.getById?.(e)
}), Na = () => r({
  queryKey: [ds],
  queryFn: Ys.getAll
}), Ra = (e) => r({
  enabled: !!e,
  queryKey: [ds, e],
  queryFn: () => Ys.getById?.(e)
}), ga = () => r({
  queryFn: ut.getAll,
  queryKey: [D]
}), _a = (e) => r({
  enabled: !!e,
  queryKey: [D, e],
  queryFn: () => ut.getById?.(e)
}), Oa = () => r({
  queryFn: at.getAll,
  queryKey: [M]
}), pa = (e) => r({
  enabled: !!e,
  queryKey: [M, e],
  queryFn: () => at.getById?.(e)
}), Fa = () => r({
  queryKey: [ke],
  queryFn: ot.getAll
}), Pa = (e) => r({
  enabled: !!e,
  queryKey: [ke, e],
  queryFn: () => ot.getById?.(e)
}), qa = () => r({
  queryKey: [_],
  queryFn: Ve.getAll
}), $a = (e) => r({
  enabled: !!e,
  queryKey: [_, e],
  queryFn: () => Ve.getById?.(e)
}), ma = (e) => r({
  enabled: !!e,
  queryKey: [_, S, e],
  queryFn: () => Ve.getAllByProvinceId?.(e)
}), Ma = () => r({
  queryFn: Ls.getAll,
  queryKey: [as]
}), Da = (e) => r({
  enabled: !!e,
  queryKey: [as, e],
  queryFn: () => Ls.getById?.(e)
}), Ka = () => r({
  queryKey: [G],
  queryFn: _e.getAll
}), wa = (e) => r({
  enabled: !!e,
  queryKey: [On, e],
  queryFn: () => _e.getAllProc(e)
}), Ua = (e) => r({
  enabled: !!e,
  queryKey: [G, e],
  queryFn: () => _e.getById?.(e)
}), Ya = (e) => r({
  enabled: !!e,
  queryKey: [G, e],
  queryFn: () => _e.getByTag?.(e)
}), ha = () => r({
  queryFn: it.getAll,
  queryKey: [F]
}), fa = (e) => r({
  enabled: !!e,
  queryKey: [F, e],
  queryFn: () => it.getById?.(e)
}), La = () => r({
  queryKey: [he],
  queryFn: Oe.getAll
}), Va = () => r({
  queryKey: [En],
  queryFn: Oe.getAllProc
}), va = (e) => r({
  enabled: !!e,
  queryKey: [he, e],
  queryFn: () => Oe.getById?.(e)
}), Ba = () => r({
  queryFn: Tt.getAll,
  queryKey: [m]
}), Ga = (e) => r({
  enabled: !!e,
  queryKey: [m, e],
  queryFn: () => Tt.getById?.(e)
}), ba = () => r({
  queryFn: vs.getAll,
  queryKey: [ns]
}), Qa = (e) => r({
  enabled: !!e,
  queryKey: [ns, e],
  queryFn: () => vs.getById?.(e)
}), Ha = () => r({
  queryKey: [E],
  queryFn: pe.getAll
}), ja = () => r({
  queryKey: [E],
  queryFn: pe.getAllProc
}), ka = (e) => r({
  enabled: !!e,
  queryKey: [E, e],
  queryFn: () => pe.getById?.(e)
}), Wa = () => r({
  queryKey: [Cs],
  queryFn: Bs.getAll
}), za = (e) => r({
  enabled: !!e,
  queryKey: [Cs, e],
  queryFn: () => Bs.getById?.(e)
}), Ja = () => r({
  queryKey: [$t],
  queryFn: Gs.getAll
}), xa = (e) => r({
  enabled: !!e,
  queryKey: [$t, e],
  queryFn: () => Gs.getById?.(e)
}), Za = () => r({
  queryKey: [Ss],
  queryFn: Qs.getAll
}), Xa = (e) => r({
  enabled: !!e,
  queryKey: [Ss, e],
  queryFn: () => Qs.getById?.(e)
}), eo = () => r({
  queryFn: Hs.getAll,
  queryKey: [os]
}), to = (e) => r({
  enabled: !!e,
  queryKey: [os, e],
  queryFn: () => Hs.getById?.(e)
}), so = () => r({
  queryFn: bs.getAll,
  queryKey: [ls]
}), no = (e) => r({
  enabled: !!e,
  queryKey: [ls, e],
  queryFn: () => bs.getById?.(e)
}), ro = () => r({
  queryKey: [Rs],
  queryFn: js.getAll
}), uo = (e) => r({
  enabled: !!e,
  queryKey: [Rs, e],
  queryFn: () => js.getById?.(e)
}), ao = (e) => r({
  enabled: !!e,
  queryKey: [Re],
  queryFn: () => Rt.getAll(e)
}), oo = () => r({
  queryFn: Ue.getAll,
  queryKey: [Y]
}), co = (e) => r({
  enabled: !!e,
  queryFn: () => Ue.getById?.(e),
  queryKey: [Y, e]
}), io = () => r({
  queryFn: ks.getAll,
  queryKey: [Ns]
}), lo = (e) => r({
  enabled: !!e,
  queryKey: [Ns, e],
  queryFn: () => ks.getById?.(e)
}), yo = () => r({
  queryFn: Vs.getAll,
  queryKey: [As]
}), To = (e) => r({
  enabled: !!e,
  queryKey: [As, e],
  queryFn: () => Vs.getById?.(e)
}), Io = () => r({
  queryFn: Ye.getAll,
  queryKey: [L]
}), Eo = (e) => r({
  enabled: !!e,
  queryKey: [L, e],
  queryFn: () => Ye.getById?.(e)
}), Co = () => r({
  queryFn: Ft.getAll,
  queryKey: [ys]
}), So = (e) => r({
  enabled: !!e,
  queryKey: [ys, e],
  queryFn: () => Ft.getById?.(e)
}), Ao = () => r({
  queryFn: Js.getAll,
  queryKey: [Is]
}), No = (e) => r({
  enabled: !!e,
  queryKey: [Is, e],
  queryFn: () => Js.getById?.(e)
}), Ro = () => r({
  queryKey: [gs],
  queryFn: xs.getAll
}), go = (e) => r({
  enabled: !!e,
  queryKey: [gs, e],
  queryFn: () => xs.getById?.(e)
}), _o = () => r({
  queryFn: Ws.getAll,
  queryKey: [cs]
}), Oo = (e) => r({
  enabled: !!e,
  queryKey: [cs, e],
  queryFn: () => Ws.getById?.(e)
}), po = () => r({
  queryFn: Zs.getAll,
  queryKey: [is]
}), Fo = (e) => r({
  enabled: !!e,
  queryKey: [is, e],
  queryFn: () => Zs.getById?.(e)
}), Po = () => r({
  queryFn: It.getAll,
  queryKey: [h]
}), qo = (e) => r({
  enabled: !!e,
  queryKey: [h, e],
  queryFn: () => It.getById?.(e)
}), $o = () => r({
  queryFn: Dn.getAll,
  queryKey: [In]
}), mo = () => r({
  queryFn: Et.getAll,
  queryKey: [V]
}), Mo = (e) => r({
  enabled: !!e,
  queryKey: [V, e],
  queryFn: () => Et.getById?.(e)
}), Do = () => r({
  queryFn: gt.getAll,
  queryKey: [mt]
}), Ko = (e) => r({
  enabled: !!e,
  queryKey: [mt, e],
  queryFn: () => gt.getById?.(e)
}), wo = () => r({
  queryFn: dt.getAll,
  queryKey: [f]
}), Uo = (e) => r({
  enabled: !!e,
  queryKey: [f, e],
  queryFn: () => dt.getById?.(e)
}), Yo = () => r({
  queryFn: zs.getAll,
  queryKey: [Ts]
}), ho = (e) => r({
  enabled: !!e,
  queryFn: () => zs.getById?.(e),
  queryKey: [Ts, e]
}), Bi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useFetchAcademicLevelTypes: ba,
  useFetchAccountTypes: ra,
  useFetchAccounts: pu,
  useFetchAddressTypes: aa,
  useFetchBanks: ru,
  useFetchClients: Pu,
  useFetchClientsCompanies: ha,
  useFetchClientsProc: qu,
  useFetchCompanies: Hu,
  useFetchCompanyTypes: ca,
  useFetchContactPhoto: Ea,
  useFetchContactTypes: Ta,
  useFetchContactTypesDni: Ma,
  useFetchContacts: Du,
  useFetchCountries: ku,
  useFetchCurrencies: zu,
  useFetchDocuments: Lu,
  useFetchFamilyRelationships: Ba,
  useFetchFinances: wu,
  useFetchFinancesAmortizations: Wa,
  useFetchFinancesAssuranceTypes: Ja,
  useFetchFinancesGroups: Sa,
  useFetchFinancesLatePaymentCalcs: io,
  useFetchFinancesMethodPayments: Za,
  useFetchFinancesRehooks: Fa,
  useFetchFinancesTypeConceptsClosings: Do,
  useFetchFinancesTypes: Na,
  useFetchFrequencyPayments: yo,
  useFetchGenders: mu,
  useFetchGeneralSettings: Ka,
  useFetchGeneralSettingsCategories: Ro,
  useFetchGeneralSettingsOptions: ro,
  useFetchGeneralSettingsProc: wa,
  useFetchInventoryAdjustments: Ha,
  useFetchInventoryAdjustmentsDetails: $o,
  useFetchInventoryAdjustmentsProc: ja,
  useFetchInventoryAdjustmentsReasons: mo,
  useFetchInventoryProductCategories: Po,
  useFetchInventoryProductsBrands: oo,
  useFetchInventoryProductsBrandsModels: wo,
  useFetchInventoryProductsListPrices: po,
  useFetchInventoryProductsPrices: ao,
  useFetchInventoryProductsQualities: _o,
  useFetchInventoryProductsTypes: eo,
  useFetchInventoryProductsUnits: so,
  useFetchInventoryTransfers: La,
  useFetchInventoryTransfersDetails: Ao,
  useFetchInventoryTransfersProc: Va,
  useFetchInventoryVehicleCylinders: Co,
  useFetchInventoryVehicleFuelTypes: Io,
  useFetchMaritalStatus: Oa,
  useFetchModules: Ru,
  useFetchMonths: Au,
  useFetchMunicipalities: qa,
  useFetchMunicipalitiesByProvince: ma,
  useFetchNationalities: ga,
  useFetchOccupations: ea,
  useFetchOneAcademicLevelType: Qa,
  useFetchOneAccount: Fu,
  useFetchOneAccountType: ua,
  useFetchOneAddressType: oa,
  useFetchOneBank: uu,
  useFetchOneClient: $u,
  useFetchOneClientCompany: fa,
  useFetchOneCompany: ju,
  useFetchOneCompanyType: ia,
  useFetchOneContact: Ku,
  useFetchOneContactType: Ia,
  useFetchOneContactTypeDni: Da,
  useFetchOneCountry: Wu,
  useFetchOneCurrency: Ju,
  useFetchOneDocument: Vu,
  useFetchOneFamilyRelationship: Ga,
  useFetchOneFinance: Uu,
  useFetchOneFinancesAmortization: za,
  useFetchOneFinancesAssuranceType: xa,
  useFetchOneFinancesGroup: Aa,
  useFetchOneFinancesLatePaymentCalc: lo,
  useFetchOneFinancesMethodPayment: Xa,
  useFetchOneFinancesRehook: Pa,
  useFetchOneFinancesType: Ra,
  useFetchOneFinancesTypeConceptsClosing: Ko,
  useFetchOneFrequencyPayment: To,
  useFetchOneGender: Mu,
  useFetchOneGeneralSetting: Ua,
  useFetchOneGeneralSettingByTag: Ya,
  useFetchOneGeneralSettingsCategory: go,
  useFetchOneGeneralSettingsOption: uo,
  useFetchOneInventoryAdjustment: ka,
  useFetchOneInventoryAdjustmentsReason: Mo,
  useFetchOneInventoryProductCategory: qo,
  useFetchOneInventoryProductsBrand: co,
  useFetchOneInventoryProductsBrandsModel: Uo,
  useFetchOneInventoryProductsListPrice: Fo,
  useFetchOneInventoryProductsQuality: Oo,
  useFetchOneInventoryProductsType: to,
  useFetchOneInventoryProductsUnit: no,
  useFetchOneInventoryTransfer: va,
  useFetchOneInventoryTransfersDetail: No,
  useFetchOneInventoryVehicleCylinder: So,
  useFetchOneInventoryVehicleFuelType: Eo,
  useFetchOneMaritalStatus: pa,
  useFetchOneModule: gu,
  useFetchOneMonth: Nu,
  useFetchOneMunicipality: $a,
  useFetchOneNationality: _a,
  useFetchOneOccupation: ta,
  useFetchOneProduct: fu,
  useFetchOneProfession: na,
  useFetchOneProvince: bu,
  useFetchOneRole: Eu,
  useFetchOneSector: Ou,
  useFetchOneStatus: Su,
  useFetchOneTax: Tu,
  useFetchOneTemplate: Bu,
  useFetchOneTemplatesType: Ca,
  useFetchOneUser: ou,
  useFetchOneVehicleTransmissionsType: ho,
  useFetchOneWarehouse: Zu,
  useFetchProducts: Yu,
  useFetchProductsProc: hu,
  useFetchProfessions: sa,
  useFetchProvinces: Gu,
  useFetchProvincesByCountry: Qu,
  useFetchRoles: Iu,
  useFetchRolesByUser: du,
  useFetchSectors: _u,
  useFetchStatus: Cu,
  useFetchTaxes: yu,
  useFetchTemplateTypes: da,
  useFetchTemplates: vu,
  useFetchUserMe: cu,
  useFetchUsers: au,
  useFetchUsersNames: lu,
  useFetchUsersPermissions: iu,
  useFetchVehicleTransmissionsTypes: Yo,
  useFetchVoucherType: ya,
  useFetchVoucherTypes: la,
  useFetchWarehouses: xu,
  useFetchWarehousesByProduct: Xu
}, Symbol.toStringTag, { value: "Module" })), fo = () => u({ mutationKey: [Nn], mutationFn: Dt.login }), Lo = () => u({
  mutationFn: Dt.refreshToken,
  mutationKey: [gn]
}), Vo = () => u({
  mutationFn: Dt.changePassword,
  mutationKey: [_n]
}), vo = () => u({
  mutationFn: Je.create,
  mutationKey: [We, i]
}), Bo = () => u({
  mutationFn: Je.update,
  mutationKey: [We, c]
}), Go = () => {
  const e = a();
  return u({
    mutationFn: At.create,
    mutationKey: [we, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [we] });
    }
  });
}, bo = () => {
  const e = a();
  return u({
    mutationFn: At.update,
    mutationKey: [we, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [we] });
    }
  });
}, Qo = () => {
  const e = a();
  return u({
    mutationFn: ze.create,
    mutationKey: [Q, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [Q] });
    }
  });
}, Ho = () => {
  const e = a();
  return u({
    mutationFn: ze.update,
    mutationKey: [Q, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [Q] });
    }
  });
}, jo = () => {
  const e = a();
  return u({
    mutationFn: ze.delete,
    mutationKey: [Q, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [Q] });
    }
  });
}, ko = () => {
  const e = a();
  return u({
    mutationFn: ge.create,
    mutationKey: [Ke, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [Ke] });
    }
  });
}, Wo = () => {
  const e = a();
  return u({
    mutationFn: ge.update,
    mutationKey: [Ke, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [Ke] });
    }
  });
}, zo = () => {
  const e = a();
  return u({
    mutationFn: Ze.create,
    mutationKey: [H, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [H] });
    }
  });
}, Jo = () => {
  const e = a();
  return u({
    mutationFn: Ze.update,
    mutationKey: [H, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [H] });
    }
  });
}, xo = () => {
  const e = a();
  return u({
    mutationFn: Ze.delete,
    mutationKey: [H, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [H] });
    }
  });
}, Zo = () => {
  const e = a();
  return u({
    mutationFn: fe.create,
    mutationKey: [S, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [S] });
    }
  });
}, Xo = () => {
  const e = a();
  return u({
    mutationFn: fe.update,
    mutationKey: [S, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [S] });
    }
  });
}, ec = () => {
  const e = a();
  return u({
    mutationFn: fe.delete,
    mutationKey: [S, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [S] });
    }
  });
}, tc = () => {
  const e = a();
  return u({
    mutationFn: tt.create,
    mutationKey: [b, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [b] });
    }
  });
}, sc = () => {
  const e = a();
  return u({
    mutationFn: tt.update,
    mutationKey: [b, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [b] });
    }
  });
}, nc = () => {
  const e = a();
  return u({
    mutationFn: tt.delete,
    mutationKey: [b, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [b] });
    }
  });
}, rc = () => {
  const e = a();
  return u({
    mutationFn: xe.create,
    mutationKey: [$, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [$]
      });
    }
  });
}, uc = () => {
  const e = a();
  return u({
    mutationFn: xe.update,
    mutationKey: [$, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [$]
      });
    }
  });
}, ac = () => {
  const e = a();
  return u({
    mutationFn: xe.delete,
    mutationKey: [$, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [$]
      });
    }
  });
}, oc = () => {
  const e = a();
  return u({
    mutationFn: et.create,
    mutationKey: [g, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [g] });
    }
  });
}, cc = () => {
  const e = a();
  return u({
    mutationFn: et.update,
    mutationKey: [g, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [g] });
    }
  });
}, ic = () => {
  const e = a();
  return u({
    mutationFn: et.delete,
    mutationKey: [g, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [g] });
    }
  });
}, lc = () => {
  const e = a();
  return u({
    mutationFn: Xe.create,
    mutationKey: [v, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [v] });
    }
  });
}, yc = () => {
  const e = a();
  return u({
    mutationFn: Xe.update,
    mutationKey: [v, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [v] });
    }
  });
}, Tc = () => {
  const e = a();
  return u({
    mutationFn: Xe.delete,
    mutationKey: [v, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [v] });
    }
  });
}, Ic = () => {
  const e = a();
  return u({
    mutationFn: Le.create,
    mutationKey: [R, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [R] });
    }
  });
}, Ec = () => {
  const e = a();
  return u({
    mutationFn: Le.update,
    mutationKey: [R, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [R] });
    }
  });
}, dc = () => {
  const e = a();
  return u({
    mutationFn: Le.delete,
    mutationKey: [R, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [R] });
    }
  });
}, Cc = () => {
  const e = a();
  return u({
    mutationFn: Le.switchMain,
    mutationKey: [Fn, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [R] });
    }
  });
}, Sc = () => {
  const e = a();
  return u({
    mutationFn: lt.create,
    mutationKey: [K, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [K]
      });
    }
  });
}, Ac = () => {
  const e = a();
  return u({
    mutationFn: lt.update,
    mutationKey: [K, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [K]
      });
    }
  });
}, Nc = () => {
  const e = a();
  return u({
    mutationFn: lt.delete,
    mutationKey: [K, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [K]
      });
    }
  });
}, Rc = () => {
  const e = a();
  return u({
    mutationFn: yt.create,
    mutationKey: [w, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [w]
      });
    }
  });
}, gc = () => {
  const e = a();
  return u({
    mutationFn: yt.update,
    mutationKey: [w, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [w]
      });
    }
  });
}, _c = () => {
  const e = a();
  return u({
    mutationFn: yt.delete,
    mutationKey: [w, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [w]
      });
    }
  });
}, Oc = () => {
  const e = a();
  return u({
    mutationFn: nt.create,
    mutationKey: [q, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [q]
      });
    }
  });
}, pc = () => {
  const e = a();
  return u({
    mutationFn: nt.update,
    mutationKey: [q, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [q]
      });
    }
  });
}, Fc = () => {
  const e = a();
  return u({
    mutationFn: nt.delete,
    mutationKey: [q, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [q]
      });
    }
  });
}, Pc = () => {
  const e = a();
  return u({
    mutationFn: rt.create,
    mutationKey: [U, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [U] });
    }
  });
}, qc = () => {
  const e = a();
  return u({
    mutationFn: rt.update,
    mutationKey: [U, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [U] });
    }
  });
}, $c = () => {
  const e = a();
  return u({
    mutationFn: rt.delete,
    mutationKey: [U, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [U] });
    }
  });
}, mc = () => {
  const e = a();
  return u({
    mutationFn: st.create,
    mutationKey: [P, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [P]
      });
    }
  });
}, Mc = () => {
  const e = a();
  return u({
    mutationFn: st.update,
    mutationKey: [P, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [P]
      });
    }
  });
}, Dc = () => {
  const e = a();
  return u({
    mutationFn: st.delete,
    mutationKey: [P, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [P]
      });
    }
  });
}, Kc = () => {
  const e = a();
  return u({
    mutationFn: Nt.create,
    mutationKey: [De, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [De] });
    }
  });
}, wc = () => {
  const e = a();
  return u({
    mutationFn: Nt.update,
    mutationKey: [De, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [De] });
    }
  });
}, Uc = () => {
  const e = a();
  return u({
    mutationFn: ut.create,
    mutationKey: [D, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [D]
      });
    }
  });
}, Yc = () => {
  const e = a();
  return u({
    mutationFn: ut.update,
    mutationKey: [D, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [D]
      });
    }
  });
}, hc = () => {
  const e = a();
  return u({
    mutationFn: ut.delete,
    mutationKey: [D, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [D]
      });
    }
  });
}, fc = () => {
  const e = a();
  return u({
    mutationFn: ct.create,
    mutationKey: [B, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [B] });
    }
  });
}, Lc = () => {
  const e = a();
  return u({
    mutationFn: ct.update,
    mutationKey: [B, c],
    onSuccess: (s, y) => {
      e.invalidateQueries({
        queryKey: [B, y?.TipoPlantillaId]
      });
    }
  });
}, Vc = () => {
  const e = a();
  return u({
    mutationFn: ct.delete,
    mutationKey: [B, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [B] });
    }
  });
}, vc = () => {
  const e = a();
  return u({
    mutationFn: at.create,
    mutationKey: [M, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [M]
      });
    }
  });
}, Bc = () => {
  const e = a();
  return u({
    mutationFn: at.update,
    mutationKey: [M, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [M]
      });
    }
  });
}, Gc = () => {
  const e = a();
  return u({
    mutationFn: at.delete,
    mutationKey: [M, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [M]
      });
    }
  });
}, bc = () => {
  const e = a();
  return u({
    mutationFn: it.create,
    mutationKey: [F, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [F]
      });
    }
  });
}, Qc = () => {
  const e = a();
  return u({
    mutationFn: it.update,
    mutationKey: [F, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [F]
      });
    }
  });
}, Hc = () => {
  const e = a();
  return u({
    mutationFn: it.delete,
    mutationKey: [F, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [F]
      });
    }
  });
}, jc = () => {
  const e = a();
  return u({
    mutationFn: Ve.create,
    mutationKey: [_, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [_] });
    }
  });
}, kc = () => {
  const e = a();
  return u({
    mutationFn: Ve.update,
    mutationKey: [_, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [_] });
    }
  });
}, Wc = () => {
  const e = a();
  return u({
    mutationFn: Ve.delete,
    mutationKey: [_, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [_] });
    }
  });
}, zc = () => u({
  mutationFn: ot.create,
  mutationKey: [ke, i]
}), Jc = () => u({
  mutationFn: ot.delete,
  mutationKey: [ke, l]
}), xc = () => u({
  mutationFn: ot.update,
  mutationKey: [ke, c]
}), Zc = () => {
  const e = a();
  return u({
    mutationFn: _e.create,
    mutationKey: [G, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [G] });
    }
  });
}, Xc = () => {
  const e = a();
  return u({
    mutationFn: _e.update,
    mutationKey: [G, c],
    onSuccess: (s, y) => {
      e.invalidateQueries({
        queryKey: [G, y?.ConfiguracionId]
      });
    }
  });
}, ei = () => {
  const e = a();
  return u({
    mutationFn: _e.updateAllSettings,
    mutationKey: [pn, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [G] });
    }
  });
}, ti = () => {
  const e = a();
  return u({
    mutationFn: Ye.create,
    mutationKey: [L, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [L]
      });
    }
  });
}, si = () => {
  const e = a();
  return u({
    mutationFn: Ye.update,
    mutationKey: [L, c],
    onSuccess: (s) => {
      e.invalidateQueries({
        queryKey: [
          L,
          s?.VehiculoTipoCombustibleId
        ]
      });
    }
  });
}, ni = () => {
  const e = a();
  return u({
    mutationFn: Ye.delete,
    mutationKey: [L, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [L]
      });
    }
  });
}, ri = () => {
  const e = a();
  return u({
    mutationFn: Oe.create,
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [he] });
    }
  });
}, ui = () => {
  const e = a();
  return u({
    mutationFn: Oe.update,
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [he] });
    }
  });
}, ai = () => {
  const e = a();
  return u({
    mutationFn: Oe.delete,
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [he] });
    }
  });
}, oi = () => {
  const e = a();
  return u({
    mutationFn: Oe.activate,
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [he] });
    }
  });
}, ci = () => u({
  mutationFn: mn.create,
  mutationKey: [dn, i]
}), ii = () => u({
  mutationFn: Mn.create,
  mutationKey: [$t, i]
}), li = () => {
  const e = a();
  return u({
    mutationFn: Tt.create,
    mutationKey: [m, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [m]
      });
    }
  });
}, yi = () => {
  const e = a();
  return u({
    mutationFn: Tt.update,
    mutationKey: [m, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [m]
      });
    }
  });
}, Ti = () => {
  const e = a();
  return u({
    mutationFn: Tt.delete,
    mutationKey: [m, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [m]
      });
    }
  });
}, Ii = () => {
  const e = a();
  return u({
    mutationFn: pe.create,
    mutationKey: [E, i],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [E] });
    }
  });
}, Ei = () => {
  const e = a();
  return u({
    mutationFn: pe.update,
    mutationKey: [E, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [E] });
    }
  });
}, di = () => {
  const e = a();
  return u({
    mutationFn: pe.delete,
    mutationKey: [E, l],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [E] });
    }
  });
}, Ci = () => {
  const e = a();
  return u({
    mutationFn: pe.activate,
    mutationKey: [E, c],
    onSuccess: () => {
      e.invalidateQueries({ queryKey: [E] });
    }
  });
}, Si = () => {
  const e = a();
  return u({
    mutationFn: Ue.create,
    mutationKey: [Y, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Y]
      });
    }
  });
}, Ai = () => {
  const e = a();
  return u({
    mutationFn: Ue.update,
    mutationKey: [Y, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Y]
      });
    }
  });
}, Ni = () => {
  const e = a();
  return u({
    mutationFn: Ue.delete,
    mutationKey: [Y, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Y]
      });
    }
  });
}, Ri = () => {
  const e = a();
  return u({
    mutationFn: Rt.create,
    mutationKey: [Re, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Re]
      });
    }
  });
}, gi = () => {
  const e = a();
  return u({
    mutationFn: Rt.update,
    mutationKey: [Re, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Re]
      });
    }
  });
}, _i = () => {
  const e = a();
  return u({
    mutationFn: Rt.delete,
    mutationKey: [Re, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [Re]
      });
    }
  });
}, Oi = () => {
  const e = a();
  return u({
    mutationFn: Et.create,
    mutationKey: [V, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [V]
      });
    }
  });
}, pi = () => {
  const e = a();
  return u({
    mutationFn: Et.update,
    mutationKey: [V, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [V]
      });
    }
  });
}, Fi = () => {
  const e = a();
  return u({
    mutationFn: Et.delete,
    mutationKey: [V, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [V]
      });
    }
  });
}, Pi = () => u({
  mutationFn: gt.update,
  mutationKey: [mt, c]
}), qi = () => u({
  mutationFn: gt.calculate,
  mutationKey: [Cn]
}), $i = () => {
  const e = a();
  return u({
    mutationFn: It.create,
    mutationKey: [h, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [h]
      });
    }
  });
}, mi = () => {
  const e = a();
  return u({
    mutationFn: It.update,
    mutationKey: [h, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [h]
      });
    }
  });
}, Mi = () => {
  const e = a();
  return u({
    mutationFn: It.delete,
    mutationKey: [h, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [h]
      });
    }
  });
}, Di = () => {
  const e = a();
  return u({
    mutationFn: dt.create,
    mutationKey: [f, i],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [f]
      });
    }
  });
}, Ki = () => {
  const e = a();
  return u({
    mutationFn: dt.update,
    mutationKey: [f, c],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [f]
      });
    }
  });
}, wi = () => {
  const e = a();
  return u({
    mutationFn: dt.delete,
    mutationKey: [f, l],
    onSuccess: () => {
      e.invalidateQueries({
        queryKey: [f]
      });
    }
  });
}, Gi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useActivateInventoryAdjustment: Ci,
  useActivateInventoryTransfer: oi,
  useAuthChangePassword: Vo,
  useAuthLogin: fo,
  useAuthRefreshToken: Lo,
  useCalculateConceptsClosing: qi,
  useCreateAddressType: mc,
  useCreateBank: Qo,
  useCreateClientCompany: bc,
  useCreateCompany: rc,
  useCreateCompanyType: Oc,
  useCreateContactType: Pc,
  useCreateCountry: oc,
  useCreateCurrency: Ic,
  useCreateDocument: tc,
  useCreateFamilyRelationship: li,
  useCreateFinancesAssurance: ci,
  useCreateFinancesAssuranceProduct: ii,
  useCreateFinancesGroup: Kc,
  useCreateFinancesRehook: zc,
  useCreateGeneralSetting: Zc,
  useCreateInventoryAdjustment: Ii,
  useCreateInventoryAdjustmentsReason: Oi,
  useCreateInventoryProductCategory: $i,
  useCreateInventoryProductsBrand: Si,
  useCreateInventoryProductsBrandsModel: Di,
  useCreateInventoryProductsPrice: Ri,
  useCreateInventoryTransfer: ri,
  useCreateMaritalStatus: vc,
  useCreateMunicipality: jc,
  useCreateNationalities: Uc,
  useCreateOccupation: Sc,
  useCreateProfession: Rc,
  useCreateProvince: Zo,
  useCreateRol: vo,
  useCreateSector: zo,
  useCreateTax: Go,
  useCreateTemplate: lc,
  useCreateTemplatesType: fc,
  useCreateUser: ko,
  useCreateVehicleFuelType: ti,
  useDeleteAddressType: Dc,
  useDeleteBank: jo,
  useDeleteClientCompany: Hc,
  useDeleteCompany: ac,
  useDeleteCompanyType: Fc,
  useDeleteContactType: $c,
  useDeleteCountry: ic,
  useDeleteCurrency: dc,
  useDeleteDocument: nc,
  useDeleteFamilyRelationship: Ti,
  useDeleteFinancesRehook: Jc,
  useDeleteInventoryAdjustment: di,
  useDeleteInventoryAdjustmentsReason: Fi,
  useDeleteInventoryProductCategory: Mi,
  useDeleteInventoryProductsBrand: Ni,
  useDeleteInventoryProductsBrandsModel: wi,
  useDeleteInventoryProductsPrice: _i,
  useDeleteInventoryTransfer: ai,
  useDeleteMaritalStatus: Gc,
  useDeleteMunicipality: Wc,
  useDeleteNationalities: hc,
  useDeleteOccupation: Nc,
  useDeleteProfession: _c,
  useDeleteProvince: ec,
  useDeleteSector: xo,
  useDeleteTemplate: Tc,
  useDeleteTemplatesType: Vc,
  useDeleteVehicleFuelType: ni,
  useSwitchCurrency: Cc,
  useUpdateAddressType: Mc,
  useUpdateAllGeneralSettings: ei,
  useUpdateBank: Ho,
  useUpdateClientCompany: Qc,
  useUpdateCompany: uc,
  useUpdateCompanyType: pc,
  useUpdateContactType: qc,
  useUpdateCountry: cc,
  useUpdateCurrency: Ec,
  useUpdateDocument: sc,
  useUpdateFamilyRelationship: yi,
  useUpdateFinanceTypeConceptsClosing: Pi,
  useUpdateFinancesGroup: wc,
  useUpdateFinancesRehook: xc,
  useUpdateGeneralSetting: Xc,
  useUpdateInventoryAdjustment: Ei,
  useUpdateInventoryAdjustmentsReason: pi,
  useUpdateInventoryProductCategory: mi,
  useUpdateInventoryProductsBrand: Ai,
  useUpdateInventoryProductsBrandsModel: Ki,
  useUpdateInventoryProductsPrice: gi,
  useUpdateInventoryTransfer: ui,
  useUpdateMaritalStatus: Bc,
  useUpdateMunicipality: kc,
  useUpdateNationalities: Yc,
  useUpdateOccupation: Ac,
  useUpdateProfession: gc,
  useUpdateProvince: Xo,
  useUpdateRol: Bo,
  useUpdateSector: Jo,
  useUpdateTax: bo,
  useUpdateTemplate: yc,
  useUpdateTemplatesType: Lc,
  useUpdateUser: Wo,
  useUpdateVehicleFuelType: si
}, Symbol.toStringTag, { value: "Module" }));
export {
  Gi as MutationHooks,
  vi as QueryApi,
  Bi as QueryHooks,
  Li as QueryStatus,
  fi as QueryTags,
  Vi as QueryUtils
};
